import { EEventWeekdays, ELiveClassHistoryDrawerTab } from '@constants';

export const CommonEventsTranslations = {
  EVENTS: {
    es: 'Eventos',
    en: 'Events',
    cat: 'Esdeveniments',
    eus: 'Ekitaldis',
    pt: 'Eventos'
  },
  BULK_EDIT_CONFIRM_TITLE: {
    es: '¿Seguro que quieres guardar estos cambios en las grabaciones?',
    en: 'Are you sure you want to save these changes to the recordings?',
    cat: 'Segur que vols desar aquests canvis a les gravacions?',
    eus: 'Ziur zaude grabazioetan aldaketa hauek gorde nahi dituzula?',
    pt: 'Tem certeza de que deseja salvar estas alterações nas gravações?'
  },
  BULK_EDIT_CONFIRM_DESC: {
    es: 'Esta acción es permanente y no podrás revertirla por tu cuenta. Asegúrate de que quieres continuar antes de guardar.',
    en: 'This action is permanent and you will not be able to revert it on your own. Make sure you want to continue before saving.',
    cat: 'Aquesta acció és permanent i no la podràs revertir pel teu compte. Assegura’t que vols continuar abans de desar.',
    eus: 'Ekintza hau iraunkorra da eta ezin izango duzu zeure kabuz desegin. Ziurtatu jarraitu nahi duzula gorde aurretik.',
    pt: 'Esta ação é permanente e você não poderá revertê-la por conta própria. Certifique-se de que deseja continuar antes de salvar.'
  },
  EDIT_LIVE_CLASSES: {
    es: 'Editar clases en directo',
    en: 'Edit live classes',
    cat: 'Editar classes en directe',
    eus: 'Zuzeneko klaseak editatu',
    pt: 'Editar aulas ao vivo'
  },
  CHANGES_SAVED_SUCCESSFULLY: {
    es: 'Cambios guardados',
    en: 'Changes saved',
    cat: 'Canvis desats',
    eus: 'Aldaketak ondo gorde dira',
    pt: 'Alterações salvas'
  },
  TITLE: {
    es: 'Título',
    en: 'Title',
    cat: 'Títol',
    eus: 'Izenburua',
    pt: 'Título'
  },
  DESCRIPTION: {
    es: 'Descripción',
    en: 'Description',
    cat: 'Descripció',
    eus: 'Deskribapena',
    pt: 'Descrição'
  },
  EVENT_TYPE: {
    es: 'Tipo de evento',
    en: 'Event type',
    cat: "Tipus d'esdeveniment",
    eus: 'Ekitaldi mota',
    pt: 'Tipo de evento'
  },
  EVENT: {
    es: 'Evento',
    en: 'Event',
    cat: 'Esdeveniment',
    eus: 'Ekitaldi',
    pt: 'Evento'
  },
  LIVE_CLASS: {
    es: 'Clase en directo',
    en: 'Live class',
    cat: 'Classe en directe',
    eus: 'Zuzeneko klasea',
    pt: 'Aula ao vivo'
  },
  DATE: {
    es: 'Fecha',
    en: 'Date',
    cat: 'Data',
    eus: 'Data',
    pt: 'Data'
  },
  HOUR: {
    es: 'Hora',
    en: 'Hour',
    cat: 'Hora',
    eus: 'Ordua',
    pt: 'Hora'
  },
  EVENT_LINK: {
    es: 'Enlace al evento',
    en: 'Event link',
    cat: "Enllaç a l'esdeveniment",
    eus: 'Gertaeraren esteka',
    pt: 'Link do evento'
  },
  ATTACH_FILE: {
    es: 'Adjuntar archivo',
    en: 'Attach file',
    cat: 'Adjuntar arxiu',
    eus: 'Fitxategia erantsi',
    pt: 'Anexar ficheiro'
  },
  CREATE: {
    es: 'Crear',
    en: 'Create',
    cat: 'Crear',
    eus: 'Sortu',
    pt: 'Criar'
  },
  SAVE: {
    es: 'Guardar',
    en: 'Save',
    cat: 'Desar',
    eus: 'Gorde',
    pt: 'Guardar'
  },
  CANCEL: {
    es: 'Cancelar',
    en: 'Cancel',
    cat: 'Cancel·lar',
    eus: 'Utzi',
    pt: 'Cancelar'
  },
  EVENT_CREATED_SUCCESSFULLY: {
    es: 'Evento creado correctamente',
    en: 'Event successfully created',
    cat: 'Esdeveniment creat amb èxit',
    eus: 'Ekitaldi ongi sortu da',
    pt: 'Evento criado com sucesso'
  },
  EVENT_UPDATED_SUCCESSFULLY: {
    es: 'Evento actualizado correctamente',
    en: 'Event successfully updated',
    cat: 'Esdeveniment actualitzat amb èxit',
    eus: 'Ekitaldi ongi eguneratu da',
    pt: 'Evento atualizado com sucesso'
  },
  CREATE_EVENT: {
    es: 'Nuevo evento',
    en: 'Create event',
    cat: 'Nou esdeveniment',
    eus: 'Ekitaldi berria',
    pt: 'Novo evento'
  },
  COURSES: {
    es: 'Cursos',
    en: 'Course',
    cat: 'Cursos',
    eus: 'Ikastaroak',
    pt: 'Cursos'
  },
  FORMATION: {
    es: 'Formación {{number}}',
    en: 'Formation {{number}}',
    cat: 'Formació {{number}}',
    eus: 'Ikastaroa {{number}}',
    pt: 'Formação {{number}}'
  },
  UPDATE_EVENT: {
    es: 'Actualizar evento',
    en: 'Update event',
    cat: 'Actualitzar esdeveniment',
    eus: 'Ekitaldi eguneratu',
    pt: 'Atualizar evento'
  },
  SPEAKERS: {
    es: 'Ponentes',
    en: 'Speakers',
    cat: 'Ponents',
    eus: 'Hizlariak',
    pt: 'Palestrantes'
  },
  INSCRIBED: {
    es: 'Inscrito',
    en: 'Inscribed',
    cat: 'Inscrit',
    eus: 'Izena eman',
    pt: 'Inscrito'
  },
  ATTEND: {
    es: 'Asistir',
    en: 'Attend',
    cat: 'Assistir',
    eus: 'Joan',
    pt: 'Assistir'
  },
  ATTACHMENT_REMOVED_CORRECTLY: {
    es: 'La grabación se ha eliminado correctamente',
    en: 'Recording successfully removed',
    cat: 'La gravació s`ha eliminat correctament',
    eus: 'Grabazioa ondo ezabatu da',
    pt: 'Gravação removida com sucesso'
  },
  MONTH: {
    es: 'Mes',
    en: 'Month',
    cat: 'Mes',
    eus: 'Hilabetea',
    pt: 'Mês'
  },
  WEEK: {
    es: 'Semana',
    en: 'Week',
    cat: 'Setmana',
    eus: 'Astea',
    pt: 'Semana'
  },
  LIST: {
    es: 'Lista',
    en: 'List',
    cat: 'Llista',
    eus: 'Zerrenda',
    pt: 'Lista'
  },
  DAY: {
    es: 'Día',
    en: 'Day',
    cat: 'Dia',
    eus: 'Eguna',
    pt: 'Dia'
  },
  TODAY: {
    es: 'Hoy',
    en: 'Today',
    cat: 'Avui',
    eus: 'Gaur',
    pt: 'Hoje'
  },
  MORE_EVENTS_TEXT: {
    es: '{{num}} Más',
    en: '{{num}} More',
    cat: '{{num}} Més',
    eus: '{{num}} Gehiago',
    pt: '{{num}} Mais'
  },
  DELETE_EVENT_CONFIRM: {
    es: '¿Estás seguro de eliminar este evento?, esta acción es irreversible',
    en: 'Are you sure you want to delete this event?, this action is irreversible',
    cat: 'Estàs segur que vols eliminar aquest esdeveniment?, aquesta acció és irreversible',
    eus: 'Ziur zaude ekitaldi hau ezabatu nahi duzula?, hau inoiz ezin da desegin',
    pt: 'Tem certeza que deseja eliminar este evento?, esta ação é irreversível'
  },
  ATTACHMENT_ADDED_CORRECTLY: {
    es: 'El archivo se ha añadido correctamente',
    en: 'The file has been added correctly',
    cat: 'L`arxiu s`ha afegit correctament',
    eus: 'Fitxategia zuzen gehitu da',
    pt: 'O ficheiro foi adicionado com sucesso'
  },
  EVENT_REMOVED_SUCCESSFULLY: {
    es: 'Evento eliminado correctamente',
    en: 'Event removed successfully',
    cat: 'Esdeveniment eliminat correctament',
    eus: 'Ekitaldi ongi ezabatu da',
    pt: 'Evento eliminado com sucesso'
  },
  TAGS: {
    es: 'Formaciones',
    en: 'Tags',
    cat: 'Etiquetes',
    eus: 'Etiketak',
    pt: 'Etiquetas'
  },
  COURSE: {
    es: 'Curso',
    en: 'Course',
    cat: 'Curs',
    eus: 'Ikastaro',
    pt: 'Curso'
  },
  RECURRING_LABEL: {
    es: '¿Es un evento único o recurrente?',
    en: 'Is it a unique or recurring event?',
    cat: '¿Es un esdeveniment únic o recurrent?',
    eus: 'Eskubide bakarra edo errepikakorra da?',
    pt: 'É um evento único ou recorrente?'
  },
  FREQUENCY: {
    es: 'Frecuencia',
    en: 'Frequency',
    cat: 'Frecuencia',
    eus: 'Errepikapen periodikoa',
    pt: 'Frequência'
  },
  RECURRING_UNIQUE: {
    es: 'Único',
    en: 'Unique',
    cat: 'Únic',
    eus: 'Eskubide bakarra',
    pt: 'Único'
  },
  RECURRING: {
    es: 'Recurrente',
    en: 'Recurring',
    cat: 'Recurrent',
    eus: 'Errepikapen bakarra',
    pt: 'Recorrente'
  },
  DATE_ONLY: {
    es: 'Fecha',
    en: 'Date',
    cat: 'Data',
    eus: 'Data',
    pt: 'Data'
  },
  TIME_ONLY: {
    es: 'Hora',
    en: 'Time',
    cat: 'Hora',
    eus: 'Ordua',
    pt: 'Hora'
  },
  WEEKDAYS: {
    es: 'Días de la semana',
    en: 'Weekdays',
    cat: 'Dies de la setmana',
    eus: 'Astearen egunak',
    pt: 'Dias da semana'
  },
  [EEventWeekdays.MONDAY]: {
    es: 'Lunes',
    en: 'Monday',
    cat: 'Dilluns',
    eus: 'Astelehena',
    pt: 'Segunda-feira'
  },
  [EEventWeekdays.TUESDAY]: {
    es: 'Martes',
    en: 'Tuesday',
    cat: 'Dimarts',
    eus: 'Asteartea',
    pt: 'Terça-feira'
  },
  [EEventWeekdays.WEDNESDAY]: {
    es: 'Miércoles',
    en: 'Wednesday',
    cat: 'Dimecres',
    eus: 'Asteazkena',
    pt: 'Quarta-feira'
  },
  [EEventWeekdays.THURSDAY]: {
    es: 'Jueves',
    en: 'Thursday',
    cat: 'Dijous',
    eus: 'Osteguna',
    pt: 'Quinta-feira'
  },
  [EEventWeekdays.FRIDAY]: {
    es: 'Viernes',
    en: 'Friday',
    cat: 'Divendres',
    eus: 'Ostirala',
    pt: 'Sexta-feira'
  },
  [EEventWeekdays.SATURDAY]: {
    es: 'Sábado',
    en: 'Saturday',
    cat: 'Dissabte',
    eus: 'Larunbata',
    pt: 'Sábado'
  },
  [EEventWeekdays.SUNDAY]: {
    es: 'Domingo',
    en: 'Sunday',
    cat: 'Diumenge',
    eus: 'Igandea',
    pt: 'Domingo'
  },
  CONFIRM_MODAL_TITLE: {
    es: 'Actualizar todos los eventos recurrentes',
    en: 'Update all recurring events',
    cat: 'Actualitzar tots els esdeveniments recurrents',
    eus: 'Eguneratu errepikapen guztiak',
    pt: 'Atualizar todos os eventos recorrentes'
  },
  CONFIRM_MODAL_CONTENT: {
    es: '¿Deseas actualizar todos los eventos recurrentes o solo este?',
    en: 'Do you want to update all recurring events or just this one?',
    cat: 'Vols actualitzar tots els esdeveniments recurrents o només aquest?',
    eus: 'Errepikapen guztiak edo bakarrik hau eguneratu nahi dituzu?',
    pt: 'Quer atualizar todos os eventos recorrentes ou apenas este?'
  },
  CONFIRM_MODAL_OK_TEXT: {
    es: 'Todos los eventos',
    en: 'All events',
    cat: 'Tots els esdeveniments',
    eus: 'Ekitaldi guztiak',
    pt: 'Todos os eventos'
  },
  CONFIRM_MODAL_CANCEL_TEXT: {
    es: 'Este evento',
    en: 'This event',
    cat: 'Aquest esdeveniment',
    eus: 'Ekitaldi hau',
    pt: 'Este evento'
  },
  TIMEZONE: {
    es: 'Zona horaria',
    en: 'Timezone',
    cat: 'Zona horària',
    eus: 'Denbora-zonal',
    pt: 'Fuso horário'
  },
  LIVE_EVENTS: {
    es: 'Clases en directo',
    en: 'Live classes',
    cat: 'Classes en directe',
    eus: 'Zuzeneko klaseak',
    pt: 'Aulas ao vivo'
  },
  FILTERS: {
    es: 'Filtros',
    en: 'Filters',
    cat: 'Filtres',
    eus: 'Fitxategiak',
    pt: 'Filtros'
  },
  VERTICAL: {
    es: 'Vertical',
    en: 'Vertical',
    cat: 'Vertical',
    eus: 'Eskuin',
    pt: 'Vertical'
  },
  TAG: {
    es: 'Formación',
    en: 'Training',
    cat: 'Formació',
    eus: 'Ikasgaia',
    pt: 'Formação'
  },
  TEACHER: {
    es: 'Profesor',
    en: 'Teacher',
    cat: 'Professor',
    eus: 'Irakaslea',
    pt: 'Professor'
  },
  CLEAR_FILTERS: {
    es: 'Borrar filtros',
    en: 'Clear filters',
    cat: 'Netejar filtres',
    eus: 'Ezabatu filtrotak',
    pt: 'Limpar filtros'
  },
  COURSE_AND_SECTION: {
    es: 'Curso y tema (opcional)',
    en: 'Course and section (optional)',
    cat: 'Curs i tema (opcional)',
    eus: 'Ikastaro eta gaia (aukerakoa)',
    pt: 'Curso e secção (opcional)'
  },
  ADD_FORMATION: {
    es: 'Añadir otra formación',
    en: 'Add another formation',
    cat: 'Afegeix una altra formació',
    eus: 'Beste ikastaroa gehitu',
    pt: 'Adicionar outra formação'
  },
  LIVE_RECORD_NAME_UPDATED_CORRECTLY: {
    es: 'El nombre de la grabación se ha actualizado correctamente',
    en: 'The live recording name has been updated correctly',
    cat: 'L`nom de l`enregistrament en directe s`ha actualitzat correctament',
    eus: 'Zuzeneko grabazioaren izena zuzen aldatu da',
    pt: 'O nome da gravação ao vivo foi atualizado com sucesso'
  },
  MESSAGE_REMOVED_CORRECTLY: {
    es: 'El mensaje se ha eliminado correctamente',
    en: 'The message has been removed correctly',
    cat: 'El missatge s`ha eliminat correctament',
    eus: 'Mezua ondo ezabatu da',
    pt: 'A mensagem foi removida com sucesso'
  },
  COMMENT_SENT_CORRECTLY: {
    es: 'Comentario enviado correctamente',
    en: 'Comment sent correctly',
    cat: 'Comentari enviat correctament',
    eus: 'Iruzkina bidali da',
    pt: 'Comentário enviado com sucesso'
  },
  MESSAGE_SENT_CORRECTLY: {
    es: 'Mensaje enviado correctamente',
    en: 'Message sent correctly',
    cat: 'Missatge enviat correctament',
    eus: 'Mezua bidali da',
    pt: 'Mensagem enviada com sucesso'
  },
  CONFIRM_CREATE_MANAGER_EVENT: {
    es: 'Vas a crear un evento para todos los usuarios',
    en: 'You are going to create an event for all users',
    cat: 'Estàs a punt de crear un esdeveniment per a tots els usuaris',
    eus: 'Erabiltzaile guztientzat ekitaldi bat sortuko duzu',
    pt: 'Você está prestes a criar um evento para todos os usuários'
  },
  CAN_NOT_CREATE_EVENT_WITHOUT_TAG: {
    es: 'Un evento debe tener una formación asignada',
    en: 'You cannot create an event without assigning a formation',
    cat: 'Un esdeveniment ha d`assignar una formació',
    eus: 'Ekitaldi bat prestakuntza bat esleitu gehitu',
    pt: 'Um evento deve ter uma formação atribuída'
  },
  LIVE_CLASSES_TOTAL_COUNT: {
    es: 'Clases',
    en: 'Classes',
    cat: 'Classes',
    eus: 'Ikasleak',
    pt: 'Aulas'
  },
  TEACHERS: {
    es: 'Profesores',
    en: 'Teachers',
    cat: 'Professors',
    eus: 'Ikasleak',
    pt: 'Professores'
  },
  ASSISTANTS: {
    es: 'Asistentes',
    en: 'Assistants',
    cat: 'Assistents',
    eus: 'Asistentziak',
    pt: 'Assistentes'
  },
  VISUALIZATIONS: {
    es: 'Visualizaciones',
    en: 'Visualizations',
    cat: 'Visualitzacions',
    eus: 'Ikusgaiak',
    pt: 'Visualizações'
  },
  DURATION: {
    es: 'Duración',
    en: 'Duration',
    cat: 'Duració',
    eus: 'Klasearen denbora',
    pt: 'Duração'
  },
  TEACHER_RATING: {
    es: 'V. profesor',
    en: 'Teacher rating',
    cat: 'V. professor',
    eus: 'Irakaslearen balioa',
    pt: 'Avaliação do professor'
  },
  CLASS_RATING: {
    es: 'V. clase',
    en: 'Class rating',
    cat: 'V. classe',
    eus: 'Klasearen balioa',
    pt: 'Avaliação da classe'
  },
  CLASS_QUALITY: {
    es: 'V. Transmisión',
    en: 'V. Transmission',
    cat: 'V. Transmissió',
    eus: 'V. Transmisioa',
    pt: 'V. Transmissão'
  },
  CALENDAR: {
    es: 'Calendario',
    en: 'Calendar',
    cat: 'Calendari',
    eus: 'Ikastaroak',
    pt: 'Calendário'
  },
  STATS: {
    es: 'Estadísticas',
    en: 'Stats',
    cat: 'Estadístiques',
    eus: 'Estatistikak',
    pt: 'Estatísticas'
  },
  HISTORY: {
    es: 'Historial',
    en: 'History',
    cat: 'Historial',
    eus: 'Historia',
    pt: 'Histórico'
  },
  ASSISTANTS_DRAWER_TITLE: {
    es: 'Asistentes ({{count}})',
    en: 'Assistants ({{count}})',
    cat: 'Assistents ({{count}})',
    eus: 'Asistentziak ({{count}})',
    pt: 'Assistentes ({{count}})'
  },
  RECORDED_PARTICIPANTS_DRAWER_TITLE: {
    es: 'Visualizaciones ({{count}})',
    en: 'Visualizations ({{count}})',
    cat: 'Visualitzacions ({{count}})',
    eus: 'Ikasleak ({{count}})',
    pt: 'Visualizações ({{count}})'
  },
  COMMENTS: {
    es: 'Comentarios',
    en: 'Comments',
    cat: 'Comentaris',
    eus: 'Ikasleak',
    pt: 'Comentários'
  },
  ONLY_WITH_RECORDINGS: {
    es: 'Solo con clases grabadas',
    en: 'Only with recorded classes',
    cat: 'Només amb classes enregistrades',
    eus: 'Bakarrik klase grabatuenekin',
    pt: 'Apenas com classes gravadas'
  },
  ACTIONS: {
    es: 'Acciones',
    en: 'Actions',
    cat: 'Accions',
    eus: 'Ekintzak',
    pt: 'Ações'
  },
  EDIT: {
    es: 'Editar',
    en: 'Edit',
    cat: 'Editar',
    eus: 'Editatu',
    pt: 'Editar'
  },
  DELETE: {
    es: 'Eliminar',
    en: 'Delete',
    cat: 'Eliminar',
    eus: 'Ezabatu',
    pt: 'Eliminar'
  },
  [ELiveClassHistoryDrawerTab.DETAIL]: {
    es: 'Detalle',
    en: 'Detail',
    cat: 'Detall',
    eus: 'Xehetasunak',
    pt: 'Detalhe'
  },
  [ELiveClassHistoryDrawerTab.RECORDING_PARTICIPANTS]: {
    es: 'Visualizaciones',
    en: 'Visualizations',
    cat: 'Visualitzacions',
    eus: 'Ikusgaiak',
    pt: 'Visualizações'
  },
  [ELiveClassHistoryDrawerTab.CLASS_COMMENTS]: {
    es: 'Comentarios',
    en: 'Comments',
    cat: 'Comentaris',
    eus: 'Iruzkina',
    pt: 'Comentários'
  },
  [ELiveClassHistoryDrawerTab.LIVE_CLASS_PARTICIPANTS]: {
    es: 'Asistentes',
    en: 'Assistants',
    cat: 'Assistents',
    eus: 'Asistentziak',
    pt: 'Assistentes'
  },
  NO_ASSISTANTS: {
    es: 'Sin asistentes',
    en: 'No assistants',
    cat: 'No assistents',
    eus: 'Ez da inor ikusi klase hau',
    pt: 'Sem assistentes'
  },
  NO_RECORDED_VIEWERS: {
    es: 'Sin visualizaciones',
    en: 'No visualizations',
    cat: 'No visualitzacions',
    eus: 'Ez da inor ikusi klase hau',
    pt: 'Sem visualizações'
  },
  NO_ASSISTANTS_DESCRIPTION: {
    es: 'Ningún alumno participó del directo',
    en: 'No one participated in the live',
    cat: 'No assistí aquesta classe',
    eus: 'Ez da inor ikusi klase hau',
    pt: 'Ninguém participou da aula ao vivo'
  },
  NO_RECORDED_VIEWERS_DESCRIPTION: {
    es: 'Ningun alumno vio esta clase',
    en: 'No one watched this class',
    cat: 'No assistí aquesta classe',
    eus: 'Ez da inor ikusi klase hau',
    pt: 'Ninguém assistiu esta aula'
  },
  RECORDS: {
    es: 'Grabaciones',
    en: 'Records',
    cat: 'Grabacions',
    eus: 'Grabazioak',
    pt: 'Gravações'
  },
  UPLOAD_ATTACHMENT: {
    es: 'Subir archivo',
    en: 'Upload file',
    cat: 'Adjuntar arxiu',
    eus: 'Fitxategia erantsi',
    pt: 'Anexar ficheiro'
  },
  DOCUMENTS: {
    es: 'Documentos',
    en: 'Documents',
    cat: 'Documents',
    eus: 'Fitxategiak',
    pt: 'Documentos'
  },
  SELECTED: {
    es: 'Seleccionados',
    en: 'Selected',
    cat: 'Seleccionats',
    eus: 'Aukeratutak',
    pt: 'Selecionados'
  },
  EVENTS_REMOVED_SUCCESSFULLY: {
    es: 'Eventos eliminados correctamente',
    en: 'Events removed successfully',
    cat: 'Esdeveniments eliminats correctament',
    eus: 'Ekitaldi guztiak ongi ezabatu dira',
    pt: 'Eventos removidos com sucesso'
  },
  ONLY_WITHOUT_COURSES: {
    es: 'Solo sin cursos',
    en: 'Only without courses',
    cat: 'Només sense cursos',
    eus: 'Bakarrik ikastaroak gabe',
    pt: 'Apenas sem cursos'
  },
  ONLY_WITHOUT_TAGS: {
    es: 'Solo sin formación',
    en: 'Only without tags',
    cat: 'Només sense formació',
    eus: 'Bakarrik ikastaroa gabe',
    pt: 'Apenas sem formação'
  },
  HISTORY_SANITY: {
    es: 'Historial (con pendientes de asignación)',
    en: 'History (with pending assignments)',
    cat: 'Historial (amb pendent d`assignacions)',
    eus: 'Historia (eskertuak dituztenekin)',
    pt: 'Histórico (com pendências de atribuição)'
  }
};
